const CalendarIcon = ({ viewBox = "0 0 12 12", className = "hayley-h-3 hayley-w-3 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M2.5 0.5V2.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5 0.5V2.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.5 5.5H11.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.5 2.5H1.5C0.947715 2.5 0.5 2.94772 0.5 3.5V10.5C0.5 11.0523 0.947715 11.5 1.5 11.5H10.5C11.0523 11.5 11.5 11.0523 11.5 10.5V3.5C11.5 2.94772 11.0523 2.5 10.5 2.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalendarIcon;
